import BaseHomeSectionListRouteStore from "./BaseHomeSectionListRouteStore";

class NakiMobileHandheldHomeSectionListRouteStore extends BaseHomeSectionListRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileHandheldHomeSectionListRouteStore;
